
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hlidaci-pes",
      function () {
        return require("private-next-pages/hlidaci-pes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hlidaci-pes"])
      });
    }
  